import React from 'react';
import { DataPanelCell, DataPanelRow, PanelBody, PanelHeading, PanelWithoutForm, TextWithLineBreaks } from '../../components/elements';
import { ISurvey } from '../../components/Surveys/Interfaces/ISurvey';
import { NullableFormattedDate } from '../../components/utils/NullableFormattedDate';

export function SurveyDetailsVerificatieBerekeningSummaryAndAdvice(props: { survey: Required<ISurvey> }) {
    return (
        <PanelWithoutForm id="VerificatieBerekeningRapport">
            <PanelHeading text="Samenvatting en advies" icon="fa fa-file-text-o"></PanelHeading>
            <PanelBody whiteBackground={true}>
                <TextWithLineBreaks text={props.survey.summaryAndAdvice} />
                {props.survey.inspectionStandardData?.jaren && (
                    <>
                        <DataPanelRow>
                            <DataPanelCell rowCount={4} text="Restlevensduur">
                                {props.survey.inspectionStandardData?.jaren} jaar{' '}
                            </DataPanelCell>
                            <DataPanelCell rowCount={4} text="Einddatum">
                                <NullableFormattedDate value={props.survey.inspectionStandardData?.einddatum}></NullableFormattedDate>{' '}
                            </DataPanelCell>
                        </DataPanelRow>
                        <TextWithLineBreaks text={props.survey.inspectionStandardData?.voorwaarden} />
                    </>
                )}
            </PanelBody>
        </PanelWithoutForm>
    );
}
